export default "__VITE_ASSET__CA5Ql4nA__"